import React from "react";
import {Flex} from "@aws-amplify/ui-react";
import D4ItemTypesSelect from "../components/d4/D4ItemTypesSelect";
import CurrencySelects from "../components/CurrencySelects";
import SearchBasePage from "./SearchBasePage";
import {ITEM_SUB_TYPES, MODES, PLATFORMS, REALM, REGIONS} from "../commons/enums/D4Enums";
import {Helmet} from "react-helmet-async";
import EiaShareButton from "../components/EiaShareButton";
import {useSearchParams} from "react-router-dom";
import {updateStatesOrLink} from "../commons/Utils/LinkParamUtils";
import {useCookies} from "react-cookie";
import {GAMES} from "../commons/enums/EiaEnums";
import {MAX_HERO_LEVEL} from "../commons/enums/D4Constants";

const baseStats = {itemPower: 0, classRequirement: "Any", levelRequirement: MAX_HERO_LEVEL};

const BestPrices = function (props) {
    const {user} = props;

    const [cookies, setCookies, removeCookies] = useCookies(['game', 'mode', 'realm', 'region', 'platform']);
    const cookiesWrapper = {
        game: cookies.game ? cookies.game : GAMES[0],
        mode: cookies.mode ? cookies.mode : MODES[0],
        realm: cookies.realm ? cookies.realm : REALM[0],
        region: cookies.region ? cookies.region : REGIONS[0],
        platform: cookies.platform ? cookies.platform : PLATFORMS[0]
    }

    const [currency, setCurrency] = React.useState({})
    const currencyFieldsForLink = [
        {name: 'type', linkParam: 'currency_type'},
        {name: 'name', linkParam: 'currency'},
    ]

    const [baseItem, setBaseItem] = React.useState({itemType: "Misc", itemSubType: ITEM_SUB_TYPES["Misc"][3], name: "Any"});
    const baseItemFieldsForLink = [
        {name: 'itemType', linkParam: 'item_type'},
        {name: 'itemSubType', linkParam: 'item_sub_type'},
    ]

    const [searchParams, setSearchParams] = useSearchParams();
    const [changedSearchParams, setChangedSearchParams] = React.useState(null);

    React.useEffect(() => {

        updateStatesOrLink(searchParams, setSearchParams, changedSearchParams, setChangedSearchParams, [
            {stateObject: currency, setStateObject: setCurrency, stateObjectFields: currencyFieldsForLink},
            {stateObject: baseItem, setStateObject: setBaseItem, stateObjectFields: baseItemFieldsForLink},
        ])
    }, [currency, baseItem, searchParams]);

    const optionalLeftElements=
        <Flex direction={"column"}>
            <CurrencySelects currency={currency} setCurrency={setCurrency} addAnyCurrencyType={false} addPrice={false} game={cookiesWrapper.game}/>
            <D4ItemTypesSelect showAmount={false} baseItem={baseItem} setBaseItem={setBaseItem} removeAny={false} hideRarity={true} hideName={true} hideTitle={true}/>
        </Flex>


    const overItemsRightElements = [
        <EiaShareButton key={"share-link"} title={"Share best prices link" + (baseItem ? " for " + baseItem.itemSubType : "")}
                        link={window.location.href}
        />
    ]

    return (
        <>
            <Helmet>
                <title>Best Prices – Easy Item Trading</title>
                <link rel="canonical" href={window.location.href}/>
                <meta name="description" content="Best Prices - Easy Item Trading - quick overview of the best prices for lair boss keys, runes, gems etc."/>
            </Helmet>
            {
                <SearchBasePage
                    user={user}
                    optionalLeftElements={optionalLeftElements}
                    currency={currency}
                    baseItem={baseItem}
                    initialBaseStats={baseStats}
                    onlyBestPricePerItemName={true}
                    overItemsRightElements={overItemsRightElements}
                />
            }
        </>
    );
}
export default BestPrices;